import React from 'react';
import { Field, ErrorMessage } from 'formik';

const Step1 = ({ formData }) => (
    <div style={{ width: '100%', maxWidth: '400px' }}>
        <p style={{ fontStyle: 'italic', textAlign: 'justify' }}>Hey there! We're glad you are joining us! Let's start by creating an account</p>

        <div className={"main-descriptions user-title"} style={{ width: '100%', marginTop: '20px' }}>
            Account Information
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label htmlFor="email">Email</label>
            <Field name="email" placeholder="dina@esnlisboa.org" className='login-input' style={{ marginTop: '5px' }} />
            <ErrorMessage name="email" component="div" style={{ color: '#CD3E3D' }} />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
            <label htmlFor="password">Password</label>
            <Field name="password" placeholder="password" type='password' className='login-input' style={{ marginTop: '5px' }} />
            <ErrorMessage name="password" component="div" style={{ color: '#CD3E3D' }} />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
            <label htmlFor="confirmPassword">Confirm Password</label>
            <Field name="confirmPassword" placeholder="password" type='password' className='login-input' style={{ marginTop: '5px' }} />
            <ErrorMessage name="confirmPassword" component="div" style={{ color: '#CD3E3D' }} />
        </div>
    </div>
);

export default Step1;
